export default function() {
    $("#photos").prop("disabled", false)
    $("#submit-photo").prop("disabled", false)
    $(':input[type="hidden"]').prop("disabled", false)
}